import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const aguaDulce = createAsyncThunk(
    'aguaDulce/getAguaDulce',
    async () => {
        try {
            const request = await axios.get("/api/sensor/getAguaDulce")
            return request.data
        } catch (error) {
            throw error
        }
    }
)
